import { PartsLinkAccessEffect } from "./parts-link-access.effect";

export const effects: any[] = [
  PartsLinkAccessEffect
]
